/**
 * company接口统一管理
 */
import {del, get, patch, post, put} from './http'

/**
 * 按企业名称搜索登记证企业
 * @param params
 */
export const getLicenseEntList = (params) => get('goodsmanual/license/ent/list', params)
/**
 * 根据企业路径获取企业详情
 * @param url
 */
export const getEntInfoByUrl = (url) => get('goodsmanual/ent/url/' + url, {})

/**
 * 获取证件企业详情
 */
export const getlicenseDetail = (enterpriseId) => get('goodsmanual/license/ent/' + enterpriseId, {})


export const getlicenseClassList = (type) => get('goodsmanual/license/class/list', {
  type: type
})

/**
 * 获取企业信息
 */
export const getEntInfo = () => get('goodsmanual/ent', {})

/**
 * 获取租户信息
 */
export const getCurrentEntInfo = () => get('goodsmanual/tenant', {})

/**
 * 编辑租户信息
 * @param params
 */
export const editCurrentEntInfo = (params) => patch('goodsmanual/tenant', params)

/**
 * 编辑企业信息
 * @param params
 */
export const editEnt = (params) => patch('goodsmanual/ent', params)
/**
 * 获取企业描述列表
 * @param params
 */
export const getEntDesList = (params) => get('goodsmanual/ent/describe/list', params)

/**
 * 新增企业描述
 * @param params
 */
export const addEntDes = (params) => post('goodsmanual/ent/describe', params)

/**
 * 编辑企业描述
 * @param describeId
 * @param params
 */
export const editEntDes = (describeId, params) => patch('goodsmanual/ent/describe/' + describeId, params)

/**
 * 批量删除企业描述
 * @param params
 */
export const delEntDes = (params) => del('goodsmanual/ent/describe', params)

/**
 * 新增公司相册
 * @param params
 */
export const addEntImage = (params) => post('goodsmanual/ent/image/single', params)


/**
 * 编辑企业图片
 * @param params
 */
export const editEntImage = (photoId, params) => patch('goodsmanual/ent/image/' + photoId, params)

/**
 * 删除企业相册
 * @param params
 */
export const delEntImage = (params) => del('goodsmanual/ent/image', params)

/**
 * 获取企业相册
 */
export const getEntimageList = () => get('goodsmanual/ent/image', {
  pageNum: 1,
  pageSize: 100
})

/**
 * 根据公司名称搜索企业
 * @param params
 */
export const getentlistbyname = (params) => get('goodsmanual/ent/search/list', params)

/**
 * 获取登录用户加入的企业列表
 */
export const getMineEntlist = () => get('goodsmanual/user/ent/list', {})

/**
 * 获取企业服务列表
 */
export const getEntServerList = () => get('goodsmanual/ent/serve/list', {})

/**
 * 添加企业服务
 * @param params
 */
export const addEntServer = (params) => post('goodsmanual/ent/serve', params)

/**
 * 编辑企业服务
 * @param serveId
 * @param params
 */
export const editEntServer = (serveId, params) => patch('goodsmanual/ent/serve/' + serveId, params)


/**
 * 获取企业服务详情
 * @param serveId
 */
export const getEntServerDetail = (serveId) => get('goodsmanual/ent/serve/' + serveId, {})


/**
 * 批量删除企业服务
 * @param params
 */
export const delEntServer = (params) => del('goodsmanual/ent/serve', params)

/**
 * 获取企业类型
 */
export const getEntTypeList = () => get('goodsmanual/ent/type/list', {})

/**
 * 编辑企业联系我们
 * @param params
 */
export const editEntContact = (params) => patch('goodsmanual/ent/communication', params)

/**
 * 获取企业联系我们
 */
export const getEntContact = () => get('goodsmanual/ent/communication', {})


/*******************************官网自定义分类*****************************************/
/**
 * zgh::: 404
 * 查询自定义官网分类
 * @param checkStatus
 */
export const getEnterproseClassList = (checkStatus) => get('goodsmanual/ent/function/list', {checkStatus: checkStatus})

/**
 * 初始化系统官网类型
 */
export const initEnterproseClass = () => post('goodsmanual/ent/function/init', {})

/**
 * 选中系统官网类型
 * @param params
 */
export const patchEnterproseClass = (params) => patch('goodsmanual/ent/function/batch', params)

/**
 * 添加官网类型
 * @param params
 */
export const addEnterproseClass = (params) => post('goodsmanual/ent/function', params)

/**
 * 修改官网类型
 * @param classId
 * @param params
 */
export const editEnterproseClass = (classId, params) => patch('goodsmanual/ent/function/' + classId, params)

/**
 * 批量删除官网类型
 * @param params
 */
export const delEnterproseClass = (params) => del('goodsmanual/ent/function', params)

/**
 * 获取官网类型详情
 * @param classId
 */
export const getEnterproseClassDetail = (classId) => get('goodsmanual/ent/function/' + classId, {})


/**
 * 获取企业通用信息列表
 * @param params
 */
export const getEntcommunalList = (params) => get('goodsmanual/ent/communal/list', params)

/**
 * 添加企业通用信息
 * @param params
 */
export const postEntcommunal = (params) => post('goodsmanual/ent/communal', params)

/**
 * 编辑企业通用信息
 * @param params
 */
export const editEntcommunal = (params) => patch('goodsmanual/ent/communal', params)

/**
 * 批量删除企业通用信息
 * @param params
 */
export const delEntcommunalList = (params) => del('goodsmanual/ent/communal', params)

/*******************************官网招聘*****************************************/

/**
 * 获取学历列表
 */
export const geteducationList = () => get('goodsmanual/recruit/education', {})

/**
 * 获取工作年限
 */
export const getworklife = () => get('goodsmanual/recruit/work', {})

/**
 * 获取招聘列表
 * @param params
 */
export const getrecruitlist = (params) => get('goodsmanual/recruit/list', params)

/**
 * 新增招聘
 * @param params
 */
export const addrecruit = (params) => post('goodsmanual/recruit', params)


/**
 * 编辑招聘
 * @param recruitId
 * @param params
 */
export const editrecruit = (recruitId, params) => patch('goodsmanual/recruit/' + recruitId, params)


/**
 * 获取招聘详情
 * @param recruitId
 */
export const getrecruitdetail = (recruitId) => get('goodsmanual/recruit/' + recruitId, {})


/**
 * 批量删除招聘信息
 * @param params
 */
export const delrecruits = (params) => del('goodsmanual/recruit', params)

/**
 * 批量上架
 * @param params
 */
export const muliteuprecruit = (params) => patch('goodsmanual/recruit/shelf', params)

/**
 * 批量下架
 * @param params
 */
export const muliteunderrecruit = (params) => patch('goodsmanual/recruit/under', params)

/*******************************官网资讯*****************************************/
/**
 * 添加企业资讯
 * @param params
 */
export const addentconsult = (params) => post('goodsmanual/news', params)

/**
 * 编辑企业资讯
 * @param consultId
 * @param params
 */
export const editentconsult = (consultId, params) => patch('goodsmanual/news/' + consultId, params)

/**
 * 批量删除
 * @param params
 */
export const delentconsult = (params) => del('goodsmanual/news', params)

/**
 * 获取资讯列表
 * @param params
 */
export const getentconsultlist = (params) => get('goodsmanual/news/list', params)

/**
 * 获取资讯详情
 * @param consultId
 */
export const getentconsultdetail = (consultId) => get('goodsmanual/news/' + consultId, {})

/**
 * 上架企业资讯
 * @param params
 */
export const shelfentconsult = (params) => patch('goodsmanual/news/shelf', params)

/**
 * 下架企业资讯
 * @param params
 */
export const underentconsult = (params) => patch('goodsmanual/news/under', params)


/*******************************官网合作企业*****************************************/

/**
 * 添加合作企业
 * @param params
 */
export const addEntCooperation = (params) => post('goodsmanual/ent/cooperation', params)

/**
 * 编辑合作企业
 * @param cooperationId
 * @param params
 */
export const editEntCooperation = (cooperationId, params) => patch('goodsmanual/ent/cooperation/' + cooperationId, params)

/**
 * 获取合作企业列表
 */
export const getEntCooperationList = () => get('goodsmanual/ent/cooperation/list', {})


/**
 * 删除合作企业
 * @param params
 */
export const delEntCooperations = (params) => del('goodsmanual/ent/cooperation', params)

/**
 * 添加合作企业案例
 * @param params
 */
export const addEntCooperationCase = (params) => post('goodsmanual/ent/case', params)

/**
 * 编辑合作合作案例
 * @param caseId
 * @param params
 */
export const editEntCooperationCase = (caseId, params) => patch('goodsmanual/ent/case/' + caseId, params)


/**
 * 获取合作企业案例列表
 */
export const getEntCooperationCaseList = (params) => get('goodsmanual/ent/case/list', params)

/**
 * 获取合作企业案例详情
 * @param caseId
 */
export const getEntCooperationCaseDetail = (caseId) => get('goodsmanual/ent/cooperation/' + caseId, {})

/**
 * 删除合作企业案例
 * @param params
 */
export const delEntCooperationCases = (params) => del('goodsmanual/ent/case', params)

/**
 * 上架合作企业案例
 * @param params
 * @returns {*}
 */
export const upEntCooperationCase = (params) => put('goodsmanual/ent/case/shelf', params)

/**
 * 下架合作企业案例
 * @param params
 * @returns {*}
 */
export const downEntCooperationCase = (params) => put('goodsmanual/ent/case/under', params)

/*******************************公司客服*****************************************/

/**
 * 新增客服
 * @param params
 */
export const addCustomerService = (params) => post('goodsmanual/customer/service', params)

/**
 * 编辑客服
 * @param customerServiceId
 * @param params
 */
export const editCustomerService = (customerServiceId, params) => patch('goodsmanual/customer/service/' + customerServiceId, params)


/**
 * 获取客服列表
 */
export const getCustomerServiceList = (params) => get('goodsmanual/customer/service/list', params)

/**
 * 获取客服详情
 * @param customerServiceId
 */
export const getCustomerServiceDetail = (customerServiceId) => get('goodsmanual/customer/service/' + customerServiceId, {})

/**
 * 批量删除客服
 * @param params
 */
export const delCustomerService = (params) => del('goodsmanual/customer/service', params)

/**
 * 更新客服启用状态
 * @param params
 */
export const enableCustomerService = (params) => put('goodsmanual/customer/service/enable', params)


/*******************************公司精英团队*****************************************/

/**
 * 新建精英团队
 * @param params
 */
export const addEntTeam = (params) => post('goodsmanual/ent/team', params)

/**
 * 编辑精英团队
 * @param teamId
 * @param params
 */
export const editEntTeam = (teamId, params) => patch('goodsmanual/ent/team/' + teamId, params)

/**
 * 获取精英团队列表
 * @param params
 */
export const getEntTeamList = (params) => get('goodsmanual/ent/team/list', params)


/**
 * 获取团队详情
 * @param teamId
 */
export const getEntTeamDetail = (teamId) => get('goodsmanual/ent/team/' + teamId, {})

/**
 * 批量删除团队
 * @param params
 */
export const delEntTeams = (params) => del('goodsmanual/ent/team', params)

/**
 * 团队上下架
 * @param params
 */
export const applyEntTeams = (params) => put('goodsmanual/ent/team/shelf', params)

/**
 * 获取团队成员列表
 * @param params
 */
export const getTeamMember = (params) => get('goodsmanual/ent/team/member/list', params)

/**
 * 新增成员
 * @param params
 */
export const addTeamMember = (params) => post('goodsmanual/ent/team/member', params)

/**
 * 编辑成员
 * @param memberId
 * @param params
 */
export const editTeamMember = (memberId, params) => patch('goodsmanual/ent/team/member/' + memberId, params)


/**
 * 获取成员详情
 * @param memberId
 */
export const getTeamMemberDetail = (memberId) => get('goodsmanual/ent/team/member/' + memberId, {})

/**
 * 批量删除成员
 * @param params
 */
export const delTeamMemners = (params) => del('goodsmanual/ent/team/member', params)

/*******************************公司部门*****************************************/

/**
 * 获取公司部门列表
 */
export const getDepartmentList = () => get('goodsmanual/personnel/department/all/list', {})

/**
 * 添加部门
 * @param params
 */
export const addDepartment = (params) => post('goodsmanual/personnel/department', params)


/**
 * 编辑部门
 * @param departmentId
 * @param params
 */
export const editDepartment = (departmentId, params) => patch('goodsmanual/personnel/department/' + departmentId, params)


/**
 * 删除部门
 * @param params
 */
export const delDepartment = (params) => del('goodsmanual/personnel/department', params)

/**
 * 部门排序
 */
export const sortDepartment = (params) => put('goodsmanual/personnel/department/sort', params)

/*******************************公司职位*****************************************/

/**
 * 获取职位列表
 */
export const getPositionList = () => get('goodsmanual/personnel/position/all/list', {})


/**
 * 新增职位
 * @param params
 */
export const addPosition = (params) => post('goodsmanual/personnel/position', params)


/**
 * 编辑职位
 * @param positionId
 * @param params
 */
export const editPosition = (positionId, params) => patch('goodsmanual/personnel/position/' + positionId, params)


/**
 * 删除职位
 * @param positionId
 */
export const delPosition = (params) => del('goodsmanual/personnel/position', params)


/*******************************公司员工*****************************************/

/**
 * 获取员工列表
 * @param params
 */
export const getEmployeelist = (params) => get('goodsmanual/personnel/employee/list', params)


/**
 * 新增员工
 * @param params
 */
export const addEmployee = (params) => post('goodsmanual/personnel/employee', params)

/**
 * 编辑员工
 * @param employeeId
 * @param params
 */
export const editEmployee = (employeeId, params) => patch('goodsmanual/personnel/employee/' + employeeId, params)

/**
 * 获取员工详情
 * @param employeeId
 */
export const getEmployeeDetail = (employeeId) => get('goodsmanual/personnel/employee/' + employeeId, {})


/**
 * 批量删除员工
 * @param params
 */
export const delEmployees = (params) => del('goodsmanual/personnel/employee', params)
